import { MenuItem, FormControl, FormControlLabel } from '@material-ui/core'
import React from 'react'
import { Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Checkbox } from 'components/common/FormInputs'
import SelectInput from 'components/common/Form/SelectInput'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import { StyledLookupTaskSectionWrapper } from '../Tasks.styles'
import {
  LookupTaskSectionProps,
  JobInputsAdmin,
} from './LookupTaskSection.types'
import messages from '../translate'

export const LookupTaskSection = ({
  intl: { formatMessage },
  submitting,
  onChangeTable,
  onChangeColumn,
  handleChange,
  tableFieldName,
  columnFieldName,
  createsNewRowFieldName,
  lookupTablesSource,
  columnList,
  tableValue,
  columnValue,
  tableLabel,
  columnLabel,
}: LookupTaskSectionProps) => (
  <StyledLookupTaskSectionWrapper className="form-group">
    <Field
      name={tableFieldName}
      label={tableLabel}
      component={SelectInput}
      disabled={submitting}
      onChange={onChangeTable}>
      {lookupTablesSource.map(item => (
        <MenuItem button key={item.id} value={item.id}>
          {item.title}
        </MenuItem>
      ))}
    </Field>
    <Field
      name={columnFieldName}
      label={columnLabel}
      component={SelectInput}
      disabled={submitting || !columnList.length}
      onChange={onChangeColumn}
      validate={tableValue ? getValidator(VALIDATOR_IS_EMPTY) : undefined}>
      {columnList.map(item => (
        <MenuItem button key={item.key} value={item.key}>
          {item.title}
        </MenuItem>
      ))}
    </Field>
    <FormControl>
      <FormControlLabel
        label={formatMessage(messages.createsNewRowInTheTable)}
        disabled={submitting || !columnValue}
        className="form-label"
        control={
          <Field
            name={createsNewRowFieldName}
            component={Checkbox}
            type="checkbox"
            color="primary"
            parse={val => handleChange(val, createsNewRowFieldName)}
          />
        }
      />
    </FormControl>
  </StyledLookupTaskSectionWrapper>
)

export default connect(
  (state: { getIn: (path: Array<string>) => JobInputsAdmin }) => ({
    lookupTablesSource: state.getIn(['jobInputsAdmin', 'lookupTablesSource']),
  }),
)(injectIntl(LookupTaskSection))
